package com.karawek.core.ui.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.unit.dp

object CoreShapes {
    val xs  = RoundedCornerShape(6.dp)    // small chips, tags, badges
    val sm  = RoundedCornerShape(10.dp)   // small elements
    val md  = RoundedCornerShape(12.dp)   // inputs, OTP boxes
    val lg  = RoundedCornerShape(14.dp)   // buttons
    val xl  = RoundedCornerShape(18.dp)   // cards
    val xxl = RoundedCornerShape(24.dp)   // sheets, large surfaces
    val pill = RoundedCornerShape(999.dp) // fully-round badges, pills
}
